// ID проектов
// В базе хранятся в таблице nik.project
// Вынес в константы, т.к. при авторизации надо передавать нужны ID проекта
export const PROJECT_AVTOAPP = '8f3be8a7-dcfc-4f3b-be03-71b0e7d19e5e';
// export const PROJECT_VEZEMKOLESA = 'd202b3fa-7be6-4d9b-adbe-1c4d7938e942';  -- пока данный параметр не используется в админке.
